import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "dr" }
const _hoisted_2 = { class: "dr-head" }
const _hoisted_3 = { class: "dr-title" }
const _hoisted_4 = { class: "dr-tools" }
const _hoisted_5 = { class: "dr-date dr-city" }
const _hoisted_6 = { class: "dr-date dr-city" }
const _hoisted_7 = { class: "dr-date" }
const _hoisted_8 = ["max"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_12 = {
  key: 1,
  class: "ph ph-file-pdf",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "dr-kpis" }
const _hoisted_14 = { class: "dr-kpi" }
const _hoisted_15 = { class: "dr-kpi" }
const _hoisted_16 = { class: "dr-kpi is-hot" }
const _hoisted_17 = { class: "dr-kpi" }
const _hoisted_18 = { class: "dr-card" }
const _hoisted_19 = { class: "dr-filters" }
const _hoisted_20 = { class: "dr-search" }
const _hoisted_21 = { class: "dr-period" }
const _hoisted_22 = { class: "table-responsive tr-scroll dr-table-wrap" }
const _hoisted_23 = { class: "table dr-table align-middle mb-0" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  colspan: "14",
  class: "dr-empty"
}
const _hoisted_28 = {
  class: "dr-driver",
  "data-label": "Livreur"
}
const _hoisted_29 = {
  key: 0,
  class: "dr-tag"
}
const _hoisted_30 = {
  key: 1,
  class: "d-block dr-city-name"
}
const _hoisted_31 = {
  key: 2,
  class: "d-block text-muted"
}
const _hoisted_32 = {
  class: "text-center",
  "data-label": "Affectés"
}
const _hoisted_33 = {
  class: "text-center",
  "data-label": "Livrés"
}
const _hoisted_34 = {
  class: "text-center",
  "data-label": "TDL (%)"
}
const _hoisted_35 = {
  class: "text-center",
  "data-label": "Refusés"
}
const _hoisted_36 = {
  class: "text-center",
  "data-label": "En cours"
}
const _hoisted_37 = {
  class: "text-center",
  "data-label": "Annulés"
}
const _hoisted_38 = {
  class: "text-center",
  "data-label": "Reportés"
}
const _hoisted_39 = {
  class: "text-center",
  "data-label": "Colis remboursés"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  class: "text-center",
  "data-label": "Colis échangés"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  class: "text-center dr-hot",
  "data-label": "À retourner à l'agence"
}
const _hoisted_44 = ["title"]
const _hoisted_45 = {
  key: 0,
  class: "d-block text-muted"
}
const _hoisted_46 = {
  class: "text-center",
  "data-label": "Retours reçus"
}
const _hoisted_47 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_48 = {
  class: "text-center dr-actions",
  "data-label": "Détail"
}
const _hoisted_49 = ["disabled", "aria-label", "onClick"]
const _hoisted_50 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_51 = {
  key: 1,
  class: "ph ph-file-pdf",
  "aria-hidden": "true"
}
const _hoisted_52 = {
  key: 0,
  class: "dr-detail-row"
}
const _hoisted_53 = { colspan: "14" }
const _hoisted_54 = {
  key: 0,
  class: "dr-detail"
}
const _hoisted_55 = { class: "table table-sm mb-2" }
const _hoisted_56 = { class: "text-end" }
const _hoisted_57 = { class: "text-end" }
const _hoisted_58 = {
  key: 1,
  class: "dr-detail"
}
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "table table-sm mb-0" }
const _hoisted_61 = { class: "text-end" }
const _hoisted_62 = { class: "text-end" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = {
  class: "text-center",
  "data-label": "Affectés"
}
const _hoisted_65 = {
  class: "text-center",
  "data-label": "Livrés"
}
const _hoisted_66 = {
  class: "text-center",
  "data-label": "TDL (%)"
}
const _hoisted_67 = {
  class: "text-center",
  "data-label": "Refusés"
}
const _hoisted_68 = {
  class: "text-center",
  "data-label": "En cours"
}
const _hoisted_69 = {
  class: "text-center",
  "data-label": "Annulés"
}
const _hoisted_70 = {
  class: "text-center",
  "data-label": "Reportés"
}
const _hoisted_71 = {
  class: "text-center",
  "data-label": "Colis remboursés"
}
const _hoisted_72 = {
  class: "text-center",
  "data-label": "Colis échangés"
}
const _hoisted_73 = {
  class: "text-center dr-hot-total",
  "data-label": "À retourner à l'agence"
}
const _hoisted_74 = {
  class: "text-end text-nowrap",
  "data-label": "Bon de paiement"
}
const _hoisted_75 = {
  class: "text-center",
  "data-label": "Retours reçus"
}
const _hoisted_76 = {
  key: 0,
  class: "dr-pager",
  "aria-label": "Pagination des livreurs"
}
const _hoisted_77 = { class: "dr-pager-info" }
const _hoisted_78 = { class: "dr-pager-size" }
const _hoisted_79 = ["value"]
const _hoisted_80 = {
  key: 0,
  class: "dr-pager-pages"
}
const _hoisted_81 = ["disabled"]
const _hoisted_82 = ["disabled", "aria-current", "onClick"]
const _hoisted_83 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_3, "État des livreurs — " + _toDisplayString(_ctx.cityLabel), 1),
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "dr-sub" }, "Contrôle du matin : colis de la veille, retours agence et paiements.", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _cache[12] || (_cache[12] = _createElementVNode("span", null, "Zone", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.zoneId,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.zoneId) = $event)),
              _ctx.onZoneChange
            ],
            options: _ctx.zones,
            reduce: (z) => z.id,
            label: "name",
            placeholder: "Toutes les zones"
          }, null, 8, ["modelValue", "options", "reduce", "onUpdate:modelValue"])
        ]),
        _createElementVNode("label", _hoisted_6, [
          _cache[13] || (_cache[13] = _createElementVNode("span", null, "Ville", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.cityId,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cityId) = $event)),
              _ctx.onCityChange
            ],
            options: _ctx.zoneCities,
            reduce: (c) => c.id,
            label: "name",
            placeholder: "Toutes les villes"
          }, null, 8, ["modelValue", "options", "reduce", "onUpdate:modelValue"])
        ]),
        _createElementVNode("label", _hoisted_7, [
          _cache[14] || (_cache[14] = _createElementVNode("span", null, "Journée suivie", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
            type: "date",
            class: "form-control",
            max: _ctx.today,
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFilterChange && _ctx.onFilterChange(...args)))
          }, null, 40, _hoisted_8), [
            [_vModelText, _ctx.date]
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary",
          disabled: _ctx.loading,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fetchReport()))
        }, _cache[15] || (_cache[15] = [
          _createElementVNode("i", {
            class: "ph ph-arrow-clockwise",
            "aria-hidden": "true"
          }, null, -1),
          _createTextVNode(" Actualiser ", -1)
        ]), 8, _hoisted_9),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          disabled: _ctx.pdfLoading === 'summary',
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openSummaryPdf && _ctx.openSummaryPdf(...args)))
        }, [
          (_ctx.pdfLoading === 'summary')
            ? (_openBlock(), _createElementBlock("span", _hoisted_11))
            : (_openBlock(), _createElementBlock("i", _hoisted_12)),
          _cache[16] || (_cache[16] = _createTextVNode(" PDF de l'état ", -1))
        ], 8, _hoisted_10)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "dr-kpi-icon tone-info" }, [
          _createElementVNode("i", {
            class: "ph ph-moped",
            "aria-hidden": "true"
          })
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.totals.drivers), 1),
          _cache[17] || (_cache[17] = _createElementVNode("span", null, "Livreurs actifs sur la journée", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "dr-kpi-icon tone-success" }, [
          _createElementVNode("i", {
            class: "ph ph-package",
            "aria-hidden": "true"
          })
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.totals.delivered) + " / " + _toDisplayString(_ctx.totals.assigned), 1),
          _createElementVNode("span", null, "Livrés / affectés · TDL " + _toDisplayString(_ctx.pct(_ctx.totals.tdl)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "dr-kpi-icon tone-orange" }, [
          _createElementVNode("i", {
            class: "ph ph-arrow-u-down-left",
            "aria-hidden": "true"
          })
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.totals.to_return), 1),
          _createElementVNode("span", null, "À retourner à l'agence · " + _toDisplayString(_ctx.totals.received) + " déjà reçu(s)", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "dr-kpi-icon tone-warning" }, [
          _createElementVNode("i", {
            class: "ph ph-wallet",
            "aria-hidden": "true"
          })
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.money(_ctx.totals.pay_amount)), 1),
          _createElementVNode("span", null, "Bons de paiement (" + _toDisplayString(_ctx.$devis) + ")", 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[22] || (_cache[22] = _createElementVNode("i", {
            class: "ph ph-magnifying-glass",
            "aria-hidden": "true"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.search) = $event)),
            type: "search",
            placeholder: "Rechercher un livreur…",
            "aria-label": "Rechercher un livreur"
          }, null, 512), [
            [_vModelText, _ctx.search]
          ])
        ]),
        _createElementVNode("span", _hoisted_21, [
          _cache[23] || (_cache[23] = _createTextVNode(" Journée suivie ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.fmt(_ctx.report.date)), 1),
          _cache[24] || (_cache[24] = _createTextVNode(" · contrôle du ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.fmt(_ctx.report.control_date)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("table", _hoisted_23, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _cache[25] || (_cache[25] = _createElementVNode("th", null, "Livreur", -1)),
              _cache[26] || (_cache[26] = _createElementVNode("th", { class: "text-center" }, "Affectés", -1)),
              _cache[27] || (_cache[27] = _createElementVNode("th", { class: "text-center" }, "Livrés", -1)),
              _cache[28] || (_cache[28] = _createElementVNode("th", { class: "text-center" }, "TDL (%)", -1)),
              _cache[29] || (_cache[29] = _createElementVNode("th", { class: "text-center" }, "Refusés", -1)),
              _cache[30] || (_cache[30] = _createElementVNode("th", { class: "text-center" }, "En cours", -1)),
              _cache[31] || (_cache[31] = _createElementVNode("th", { class: "text-center" }, "Annulés", -1)),
              _cache[32] || (_cache[32] = _createElementVNode("th", { class: "text-center" }, "Reportés", -1)),
              _cache[33] || (_cache[33] = _createElementVNode("th", { class: "text-center" }, "Colis remboursés", -1)),
              _cache[34] || (_cache[34] = _createElementVNode("th", { class: "text-center" }, "Colis échangés", -1)),
              _cache[35] || (_cache[35] = _createElementVNode("th", { class: "text-center dr-hot-head" }, "À retourner à l'agence", -1)),
              _createElementVNode("th", _hoisted_24, "Bon de paiement (" + _toDisplayString(_ctx.$devis) + ")", 1),
              _cache[36] || (_cache[36] = _createElementVNode("th", { class: "text-center" }, "Retours reçus", -1)),
              _cache[37] || (_cache[37] = _createElementVNode("th", { class: "text-center" }, "Détail", -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_25, _cache[38] || (_cache[38] = [
                  _createElementVNode("td", {
                    colspan: "14",
                    class: "text-center py-4"
                  }, [
                    _createElementVNode("span", { class: "spinner-border spinner-border-sm" })
                  ], -1)
                ])))
              : (!_ctx.report.rows.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                    _createElementVNode("td", _hoisted_27, [
                      _cache[39] || (_cache[39] = _createElementVNode("i", {
                        class: "ph ph-moped",
                        "aria-hidden": "true"
                      }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.search ? "Aucun livreur ne correspond à votre recherche." : _ctx.emptyMessage), 1)
                    ])
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.report.rows, (row) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: row.driver_id
                    }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("strong", null, _toDisplayString(row.driver_name), 1),
                          (!row.active)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Inactif"))
                            : _createCommentVNode("", true),
                          (row.city_name)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_30, [
                                _cache[40] || (_cache[40] = _createElementVNode("i", {
                                  class: "ph ph-map-pin",
                                  "aria-hidden": "true"
                                }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(row.city_name), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (row.phone)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(row.phone), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(row.assigned), 1),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(row.delivered), 1),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["dr-tdl", _ctx.tdlTone(row.tdl)])
                          }, _toDisplayString(_ctx.pct(row.tdl)), 3)
                        ]),
                        _createElementVNode("td", _hoisted_35, _toDisplayString(row.refused), 1),
                        _createElementVNode("td", _hoisted_36, _toDisplayString(row.in_progress), 1),
                        _createElementVNode("td", _hoisted_37, _toDisplayString(row.cancelled), 1),
                        _createElementVNode("td", _hoisted_38, _toDisplayString(row.postponed), 1),
                        _createElementVNode("td", _hoisted_39, [
                          (row.refunded)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "dr-link",
                                onClick: ($event: any) => (_ctx.toggle(row.driver_id))
                              }, _toDisplayString(row.refunded), 9, _hoisted_40))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("0")
                              ], 64))
                        ]),
                        _createElementVNode("td", _hoisted_41, [
                          (row.exchanged)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "dr-link",
                                onClick: ($event: any) => (_ctx.toggle(row.driver_id))
                              }, _toDisplayString(row.exchanged), 9, _hoisted_42))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("0")
                              ], 64))
                        ]),
                        _createElementVNode("td", _hoisted_43, [
                          _createElementVNode("strong", null, _toDisplayString(row.to_return), 1)
                        ]),
                        _createElementVNode("td", {
                          class: "text-end text-nowrap",
                          "data-label": "Bon de paiement",
                          title: row.pay_refs.join(', ')
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.money(row.pay_amount)) + " ", 1),
                          (row.pay_refs.length)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_45, _toDisplayString(row.pay_refs.length) + " bon(s)", 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_44),
                        _createElementVNode("td", _hoisted_46, [
                          (row.to_return)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["dr-received", { 'is-done': row.received >= row.to_return }])
                              }, _toDisplayString(row.received) + " / " + _toDisplayString(row.to_return), 3))
                            : (_openBlock(), _createElementBlock("span", _hoisted_47, "—"))
                        ]),
                        _createElementVNode("td", _hoisted_48, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-outline-primary dr-act",
                            disabled: _ctx.pdfLoading === row.driver_id,
                            "aria-label": `PDF détaillé de ${row.driver_name}`,
                            onClick: ($event: any) => (_ctx.openDriverPdf(row))
                          }, [
                            (_ctx.pdfLoading === row.driver_id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_50))
                              : (_openBlock(), _createElementBlock("i", _hoisted_51)),
                            _cache[41] || (_cache[41] = _createTextVNode(" PDF ", -1))
                          ], 8, _hoisted_49)
                        ])
                      ]),
                      (_ctx.expanded.has(row.driver_id))
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                            _createElementVNode("td", _hoisted_53, [
                              (row.exchanged_list?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _createElementVNode("h6", null, [
                                      _cache[42] || (_cache[42] = _createElementVNode("i", {
                                        class: "ph ph-arrows-left-right",
                                        "aria-hidden": "true"
                                      }, null, -1)),
                                      _createTextVNode(" Colis échangés livrés (" + _toDisplayString(row.exchanged_list.length) + ")", 1)
                                    ]),
                                    _createElementVNode("table", _hoisted_55, [
                                      _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                          _cache[43] || (_cache[43] = _createElementVNode("th", null, "Code", -1)),
                                          _cache[44] || (_cache[44] = _createElementVNode("th", null, "Client", -1)),
                                          _cache[45] || (_cache[45] = _createElementVNode("th", null, "Destinataire", -1)),
                                          _cache[46] || (_cache[46] = _createElementVNode("th", null, "Téléphone", -1)),
                                          _cache[47] || (_cache[47] = _createElementVNode("th", null, "Ville", -1)),
                                          _createElementVNode("th", _hoisted_56, "Prix (" + _toDisplayString(_ctx.$devis) + ")", 1),
                                          _cache[48] || (_cache[48] = _createElementVNode("th", null, "Livré le", -1))
                                        ])
                                      ]),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.exchanged_list, (p) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: p.code
                                          }, [
                                            _createElementVNode("td", null, [
                                              _createElementVNode("b", null, _toDisplayString(p.code), 1)
                                            ]),
                                            _createElementVNode("td", null, _toDisplayString(p.customer_name), 1),
                                            _createElementVNode("td", null, _toDisplayString(p.receiver), 1),
                                            _createElementVNode("td", null, _toDisplayString(p.phone), 1),
                                            _createElementVNode("td", null, _toDisplayString(p.city_name), 1),
                                            _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.money(p.price)), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.fmt(p.delivery_time)), 1)
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (row.refunded_list?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _createElementVNode("h6", null, [
                                      _cache[49] || (_cache[49] = _createElementVNode("i", {
                                        class: "ph ph-receipt",
                                        "aria-hidden": "true"
                                      }, null, -1)),
                                      _createTextVNode(" Remboursements effectués (" + _toDisplayString(row.refunded_list.length) + ")", 1),
                                      (row.refunds_pending_return)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, " · " + _toDisplayString(row.refunds_pending_return) + " produit(s) à remettre à l'agence", 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("table", _hoisted_60, [
                                      _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                          _cache[50] || (_cache[50] = _createElementVNode("th", null, "Demande", -1)),
                                          _cache[51] || (_cache[51] = _createElementVNode("th", null, "Colis", -1)),
                                          _cache[52] || (_cache[52] = _createElementVNode("th", null, "Client", -1)),
                                          _cache[53] || (_cache[53] = _createElementVNode("th", null, "Destinataire", -1)),
                                          _cache[54] || (_cache[54] = _createElementVNode("th", null, "Téléphone", -1)),
                                          _createElementVNode("th", _hoisted_61, "Montant (" + _toDisplayString(_ctx.$devis) + ")", 1),
                                          _cache[55] || (_cache[55] = _createElementVNode("th", null, "Retour produit", -1)),
                                          _cache[56] || (_cache[56] = _createElementVNode("th", null, "Remboursé le", -1))
                                        ])
                                      ]),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.refunded_list, (r) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: r.ref
                                          }, [
                                            _createElementVNode("td", null, [
                                              _createElementVNode("b", null, _toDisplayString(r.ref), 1)
                                            ]),
                                            _createElementVNode("td", null, _toDisplayString(r.parcel_code), 1),
                                            _createElementVNode("td", null, _toDisplayString(r.customer_name), 1),
                                            _createElementVNode("td", null, _toDisplayString(r.receiver), 1),
                                            _createElementVNode("td", null, _toDisplayString(r.phone), 1),
                                            _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.money(r.amount)), 1),
                                            _createElementVNode("td", null, _toDisplayString(r.with_return ? "Oui" : "Non"), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.fmt(r.refunded_at)), 1)
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
          ]),
          (!_ctx.loading && _ctx.report.rows.length)
            ? (_openBlock(), _createElementBlock("tfoot", _hoisted_63, [
                _createElementVNode("tr", null, [
                  _cache[57] || (_cache[57] = _createElementVNode("td", { class: "dr-driver" }, [
                    _createTextVNode("TOTAL "),
                    _createElementVNode("small", { class: "dr-total-note" }, "(tous les livreurs)")
                  ], -1)),
                  _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.totals.assigned), 1),
                  _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.totals.delivered), 1),
                  _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.pct(_ctx.totals.tdl)), 1),
                  _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.totals.refused), 1),
                  _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.totals.in_progress), 1),
                  _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.totals.cancelled), 1),
                  _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.totals.postponed), 1),
                  _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.totals.refunded), 1),
                  _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.totals.exchanged), 1),
                  _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.totals.to_return), 1),
                  _createElementVNode("td", _hoisted_74, _toDisplayString(_ctx.money(_ctx.totals.pay_amount)), 1),
                  _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.totals.received) + " / " + _toDisplayString(_ctx.totals.to_return), 1),
                  _cache[58] || (_cache[58] = _createElementVNode("td", { class: "dr-actions" }, null, -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.pagination.total > 0)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.pagination.from) + "–" + _toDisplayString(_ctx.pagination.to) + " sur " + _toDisplayString(_ctx.pagination.total) + " livreur(s) ", 1),
            _createElementVNode("div", _hoisted_78, [
              _cache[59] || (_cache[59] = _createElementVNode("label", { for: "dr-per-page" }, "Par page", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "dr-per-page",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.perPage) = $event)),
                class: "form-select form-select-sm",
                onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onFilterChange && _ctx.onFilterChange(...args)))
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([10, 25, 50, 100], (n) => {
                  return _createElementVNode("option", {
                    key: n,
                    value: n
                  }, _toDisplayString(n), 9, _hoisted_79)
                }), 64))
              ], 544), [
                [
                  _vModelSelect,
                  _ctx.perPage,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            (_ctx.pagination.last_page > 1)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_80, [
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "dr-page-btn",
                      disabled: _ctx.loading || _ctx.page <= 1,
                      "aria-label": "Page précédente",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goTo(_ctx.page - 1)))
                    }, _cache[60] || (_cache[60] = [
                      _createElementVNode("i", {
                        class: "ph ph-caret-left",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]), 8, _hoisted_81)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageNumbers, (n) => {
                    return (_openBlock(), _createElementBlock("li", { key: n }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["dr-page-btn", { 'is-active': n === _ctx.page }]),
                        disabled: _ctx.loading,
                        "aria-current": n === _ctx.page ? 'page' : undefined,
                        onClick: ($event: any) => (_ctx.goTo(n))
                      }, _toDisplayString(n), 11, _hoisted_82)
                    ]))
                  }), 128)),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "dr-page-btn",
                      disabled: _ctx.loading || _ctx.page >= _ctx.pagination.last_page,
                      "aria-label": "Page suivante",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goTo(_ctx.page + 1)))
                    }, _cache[61] || (_cache[61] = [
                      _createElementVNode("i", {
                        class: "ph ph-caret-right",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]), 8, _hoisted_83)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _cache[62] || (_cache[62] = _createElementVNode("ul", { class: "dr-legend" }, [
        _createElementVNode("li", null, [
          _createElementVNode("b", null, "TDL"),
          _createTextVNode(" = Livrés / Affectés × 100.")
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("b", { class: "text-orange" }, "À retourner :"),
          _createTextVNode(" colis non livrés à la fin de la journée suivie (+ produits de remboursement avec retour) qui doivent revenir à l'agence. ")
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("b", { class: "text-orange" }, "Retours reçus :"),
          _createTextVNode(" colis à retourner déjà enregistrés dans un bon retour agence.")
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("b", { class: "text-orange" }, "Bon de paiement :"),
          _createTextVNode(" montant net des bons de paiement livreur contenant ces colis.")
        ])
      ], -1))
    ])
  ]))
}